import { PLANS_NAME } from "@static/config";
import { ROUTE_PATH } from "@static/route-paths";

function getPlanOverView(state: any, policyName: string) {
  switch (policyName) {
    case PLANS_NAME.SHIELD_STARTER:
      return state?.shieldStarterStep2?.planOverview;
    case PLANS_NAME.EVER_GREEN:
      const url = window?.location.hash;
      if (url && state?.everGreenStep1?.PlanData) {
        return ![
          ROUTE_PATH.EVER_GREEN_GET_STARTED,
          ROUTE_PATH.EVER_GREEN_QUOTATION,
        ].includes(url?.replace("#", "") as any);
      }
      return state?.everGreenStep1?.PlanData;
    case PLANS_NAME.CANCER_COVER_PLUS:
      return state?.cancerCoverStep1?.quotation?.totalPremium > 0;
    case PLANS_NAME.MLTC:
    default:
      return state?.mltcR3Step2?.planOverview;
  }
}

export { getPlanOverView };
